module.exports = __webpack_public_path__ + "img/sealanimation.8920f3ec.gif";